import React from 'react';

export default function InfoIcon(props) {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g fill='currentColor' fillRule='nonzero'>
          <path d='M16,4 C22.627417,4 28,9.372583 28,16 C28,22.627417 22.627417,28 16,28 C9.372583,28 4,22.627417 4,16 C4,9.372583 9.372583,4 16,4 Z M16,6 C10.4771525,6 6,10.4771525 6,16 C6,21.5228475 10.4771525,26 16,26 C21.5228475,26 26,21.5228475 26,16 C26,10.4771525 21.5228475,6 16,6 Z M16,14 C16.5513333,14 17,14.35494 17,15 L17,22 C17,22.64506 16.5513333,23 16,23 C15.4486667,23 15,22.64506 15,22 L15,15 C15,14.35494 15.4486667,14 16,14 Z M16,9.5 C16.827,9.5 17.5,10.173 17.5,11 C17.5,11.827 16.827,12.5 16,12.5 C15.173,12.5 14.5,11.827 14.5,11 C14.5,10.173 15.173,9.5 16,9.5 Z' />
        </g>
      </g>
    </svg>
  );
}
